import { TransportOrderIdView } from '../../../../models';

export class ShipmentTransportOrderPartiesListLoad {
  public static readonly type = '[ShipmentTransportOrderOuterPackagesList] Load';
  constructor(public payload: TransportOrderIdView) {}
}

export class ShipmentTransportOrderPartiesListInitialState {
  public static readonly type = '[ShipmentTransportOrderOuterPackagesList] Set Initial State';
}
